var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-schema',{attrs:{"model":_vm.model}},[_c('v-radio-group',{attrs:{"label":_vm.model.$title}},_vm._l((_vm.elements),function(element,index){return _c('v-radio',{key:index,attrs:{"label":element.text,"value":element.value}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }